export default __webpack_public_path__ + "static/media/Fascinating Fabric.73bffca0.png";